import HOne from './h-one';
export default HOne;